import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import { useReportCustomerFilterStore } from '@/store/report-customer-filter'
import { reportSummaryCustomer } from '@/api/report'
import { useQuery } from '@tanstack/react-query'
import { CardCustomerChannelSummary } from '@/components/reports-route/customer/customer-channel-summary'
import { format, subDays } from 'date-fns'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'
import { throwException } from '@/exceptions/throw-exception.js'
import QUERY_KEY from '@/constants/use-query-key.js'
import { useShallow } from 'zustand/shallow'
import RangeDatePicker from '@/components/custom/range-date-picker'

export const Route = createFileRoute('/_auth/report/customer copy')({
  beforeLoad: ({ location }) =>
    navigateGuard(location, [
      UserRole.ADMINISTRATOR,
      UserRole.SUPERVISOR,
      UserRole.TEAM_LEADER,
    ]),
  component: Customer,
})

function Customer() {
  const [rangeDate, setRangeDate] = useReportCustomerFilterStore(
    useShallow((state) => [state.rangeDate, state.setRangeDate]),
  )

  const fetchSummaryCustomer = async () => {
    const payload = {
      from_date: format(rangeDate.from_date, 'yyyy-MM-dd'),
      to_date: format(subDays(rangeDate.to_date, 1), 'yyyy-MM-dd'),
    }
    try {
      const res = await reportSummaryCustomer({ data: payload })
      return res.data
    } catch (error) {
      throwException(error)
      return []
    }
  }

  const {
    isLoading: isLoadingSummaryCustomer,
    data: queryDataSummaryCustomer,
  } = useQuery({
    queryKey: [QUERY_KEY.GET_SUMMARY_CUSTOMER_REPORT, { rangeDate }],
    queryFn: fetchSummaryCustomer,
  })

  return (
    <Layout.Body>
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-lg font-bold">Báo cáo khách hàng</h1>
        <RangeDatePicker
          rangeDate={{
            from: rangeDate.from_date,
            to: rangeDate.to_date,
          }}
          onChangeRangeDate={(value) => {
            setRangeDate({
              from_date: value.from,
              to_date: value.to,
            })
          }}
        />
      </div>

      <CardCustomerChannelSummary
        isLoadingSummaryCustomer={isLoadingSummaryCustomer}
        queryDataSummaryCustomer={queryDataSummaryCustomer}
        params={rangeDate}
      />
    </Layout.Body>
  )
}
